import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgPercentMid = function SvgPercentMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.13462C4 5.40342 5.40342 4 7.13462 4C8.86582 4 10.2692 5.40342 10.2692 7.13462C10.2692 8.86582 8.86582 10.2692 7.13462 10.2692C5.40342 10.2692 4 8.86582 4 7.13462ZM7.13462 5.5C6.23184 5.5 5.5 6.23184 5.5 7.13462C5.5 8.03739 6.23184 8.76923 7.13462 8.76923C8.03739 8.76923 8.76923 8.03739 8.76923 7.13462C8.76923 6.23184 8.03739 5.5 7.13462 5.5ZM20.7803 4.21967C21.0732 4.51256 21.0732 4.98744 20.7803 5.28033L5.28033 20.7803C4.98744 21.0732 4.51256 21.0732 4.21967 20.7803C3.92678 20.4874 3.92678 20.0126 4.21967 19.7197L19.7197 4.21967C20.0126 3.92678 20.4874 3.92678 20.7803 4.21967ZM14.7308 17.8654C14.7308 16.1342 16.1342 14.7308 17.8654 14.7308C19.5966 14.7308 21 16.1342 21 17.8654C21 19.5966 19.5966 21 17.8654 21C16.1342 21 14.7308 19.5966 14.7308 17.8654ZM17.8654 16.2308C16.9626 16.2308 16.2308 16.9626 16.2308 17.8654C16.2308 18.7682 16.9626 19.5 17.8654 19.5C18.7682 19.5 19.5 18.7682 19.5 17.8654C19.5 16.9626 18.7682 16.2308 17.8654 16.2308Z"
  })));
};

export { SvgPercentMid as ReactComponent };
//# sourceMappingURL=percent-mid.svg.js.map
